/**
 * Labstep
 *
 * @module components/ProtocolValue/Detail/Input
 * @desc Detail for Input Protocol Value
 */

import { ProtocolValueActionQRScan } from 'labstep-web/components/ProtocolValue/Action/QRScan';
import { ProtocolValueActionUpdateAmount } from 'labstep-web/components/ProtocolValue/Action/UpdateAmount';
import { ProtocolValueFormShowEditResourceItemInput } from 'labstep-web/components/ProtocolValue/Form/ShowEdit/ResourceItem/Input';
import { Divider } from 'labstep-web/core/Divider';
import { List } from 'labstep-web/core/List';
import type React from 'react';
import styles from './styles.module.scss';
import type { IProtocolValueDetailResourceItemInputProps } from './types';

export const ProtocolValueDetailResourceItemInput: React.FC<
  IProtocolValueDetailResourceItemInputProps
> = ({ protocolValue }) => (
  <List doubleSpaced>
    <ProtocolValueFormShowEditResourceItemInput
      protocolValue={protocolValue}
    />
    {!protocolValue.resource_item && (
      <>
        <Divider horizontal>OR</Divider>
        <ProtocolValueActionQRScan protocolValue={protocolValue} />
      </>
    )}
    <div className={styles.actionContainer}>
      <ProtocolValueActionUpdateAmount
        protocolValue={protocolValue}
      />
    </div>
  </List>
);
